import { SDUIResponsiveContent } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/__internal__/SDUIResponsiveContent";
import { ComponentLoggingEventParams } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/__internal__/types";
import { SDUIBackgroundIcon } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/ComponentRenderers/BackgroundIcon/SDUIBackgroundIcon";
import { SDUITypographyRenderer } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/ComponentRenderers/Typography/SDUITypographyRenderer";
import { IBackgroundIcon } from "@faire/web-api--source/indigofair/data/IBackgroundIcon";
import { IResponsiveBackgroundIcon } from "@faire/web-api--source/indigofair/data/IResponsiveBackgroundIcon";
import { IResponsiveTextElement } from "@faire/web-api--source/indigofair/data/IResponsiveTextElement";
import { ITextElement } from "@faire/web-api--source/indigofair/data/ITextElement";
import { Row } from "@faire/web/slate/Layout";
import React from "react";

export const SDUIGridHeaderRow: React.FC<{
  title?: ITextElement;
  responsiveTitle?: IResponsiveTextElement;
  backgroundIcon: IBackgroundIcon | undefined;
  responsiveBackgroundIcon: IResponsiveBackgroundIcon | undefined;
  loggingData: ComponentLoggingEventParams;
}> = ({
  title,
  responsiveTitle,
  backgroundIcon,
  responsiveBackgroundIcon,
  loggingData,
}) => {
  if (!title && !responsiveTitle) {
    return;
  }

  return (
    <Row className="relative pb-4">
      <SDUIResponsiveContent
        defaultValue={title}
        serverResponsiveValues={responsiveTitle}
        convertValueToReactElement={convertTextElementToGridTitle(loggingData)}
      />
      <SDUIBackgroundIcon
        backgroundIcon={backgroundIcon}
        responsiveBackgroundIcon={responsiveBackgroundIcon}
      />
    </Row>
  );
};

const convertTextElementToGridTitle = (
  loggingData: ComponentLoggingEventParams
) =>
  function (textElement: ITextElement | undefined) {
    return textElement ? (
      <SDUITypographyRenderer
        textElement={textElement}
        loggingData={loggingData}
      />
    ) : null;
  };
